export const DEFAULT_BOOKING_DURATION_MINUTES = 240;

export function parseTimeMinutes(value) {
  if (!value) return null;
  const match = String(value).match(/^\s*(\d{1,2})(?::(\d{2}))?\s*(am|pm)?\s*$/i);
  if (!match) return null;
  let hour = Number(match[1]);
  const minute = Number(match[2] || 0);
  const meridiem = (match[3] || "").toLowerCase();
  if (minute >= 60) return null;
  if (meridiem) {
    if (hour < 1 || hour > 12) return null;
    hour = (hour % 12) + (meridiem === "pm" ? 12 : 0);
  } else if (hour >= 24) {
    return null;
  }
  return hour * 60 + minute;
}

export function isTodayEventDate(eventDate, now = new Date()) {
  if (!eventDate) return false;
  const indiaDate = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const parts = Object.fromEntries(indiaDate.map(({ type, value }) => [type, value]));
  return eventDate === `${parts.year}-${parts.month}-${parts.day}`;
}

export function isPastEventStart(eventDate, eventTime, now = new Date()) {
  const startMinutes = parseTimeMinutes(eventTime);
  if (!eventDate || startMinutes == null) return false;

  const indiaTime = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(now);
  const parts = Object.fromEntries(indiaTime.map(({ type, value }) => [type, value]));
  const today = `${parts.year}-${parts.month}-${parts.day}`;
  if (eventDate < today) return true;
  if (eventDate > today) return false;
  return startMinutes <= Number(parts.hour) * 60 + Number(parts.minute);
}

export function parseDurationMinutes(value) {
  const text = String(value || "").trim();
  if (/\b(full|all|whole)\s+day\b/i.test(text)) return 1440;
  const match = text.match(/(\d+(?:\.\d+)?)\s*(hours?|hrs?|h|minutes?|mins?|m)\b/i);
  const plainHours = text.match(/^\s*(\d+(?:\.\d+)?)\s*$/);
  const amount = Number(match?.[1] || plainHours?.[1]);
  if (!amount) return DEFAULT_BOOKING_DURATION_MINUTES;
  const unit = (match?.[2] || "hours").toLowerCase();
  const minutes = unit.startsWith("m") ? amount : amount * 60;
  return Math.round(minutes);
}

export function eventPreparationMinutes(answers = {}) {
  const parseOptionalDuration = (value) => {
    if (!value) return 0;
    const match = String(value).match(/(\d+(?:\.\d+)?)\s*(hours?|hrs?|h|minutes?|mins?|m)\b/i);
    if (!match) return 0;
    const amount = Number(match[1]);
    return Math.round(match[2].toLowerCase().startsWith("m") ? amount : amount * 60);
  };
  const arriveBefore = parseOptionalDuration(answers.arrive_before);
  const soundcheckRequired = [true, "true", "True", "yes", "Yes", 1].includes(answers.soundcheck_required);
  return arriveBefore + (soundcheckRequired ? parseOptionalDuration(answers.soundcheck_duration) : 0);
}

export function eventBlockInterval(performanceStart, duration, prepBuffer = 0) {
  return [performanceStart - Math.max(0, prepBuffer), performanceStart + duration];
}

export function intervalsConflict(start, end, otherStart, otherEnd, gapMinutes = 0) {
  return start < otherEnd + gapMinutes && otherStart < end + gapMinutes;
}
